// extracted by mini-css-extract-plugin
export default {"productGallery":"dP-z","inQuickShop":"eP-z"};